import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Icon} from "antd";
import {setIcon} from "../../services/setIcon";

class Categories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoriesStatus: [true, true, true, true],
    };
  }

  onChangeCategoryStatus = (e, index, category) => {
    if (!category.required) {
      const categoriesStatus = [...this.state.categoriesStatus];
      categoriesStatus[index] = e.target.checked;
      this.setState({ categoriesStatus });
    }
  };

  render() {
    return (
      <div className="fixed z-100 bg-white w-full p-5 border-4 border-blue-900 max-w-3xl left-1/2 transform -translate-x-1/2">
        <Icon component={setIcon('close')} className="absolute top-1 right-1 cursor-pointer" onClick={this.props.onClose} />
        <ul>
          {this.props.categories.map((category, index) => (
            <li className="mb-3" key={category.id}>
              <input
                type="checkbox"
                checked={this.state.categoriesStatus[index]}
                onChange={(e) => this.onChangeCategoryStatus(e, index, category)}
                id={category.id}
              />
              <label
                htmlFor={category.id}
                className="d-block ml-2 text-black">
                {category.name} {category.required && `(${this.context.t('required')})`}
              </label>
              <p>{category.description}</p>
            </li>
          ))}
        </ul>
        <button className="border border-blue-900 bg-blue-900 text-white uppercase py-2 px-4"
                onClick={() => this.props.onApply(this.state.categoriesStatus)}>
          {this.context.t('Apply')}
        </button>
      </div>
    )
  }
}

Categories.contextTypes = {
  t: PropTypes.func.isRequired,
};

Categories.propTypes = {
  onClose: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  categories: PropTypes.array.isRequired,
};

export default Categories;
